import { createApp } from "vue";
import UserColumnsPage from "~/components/UserAccounts/UserColumnsPage";
import FloatingVue from "floating-vue";
import "floating-vue/dist/style.css";
import * as dayjs from "dayjs";


document.addEventListener("DOMContentLoaded", () => {
  const app = createApp({
    components: {
      UserColumnsPage
    }
  });
  app.use(FloatingVue);
  app.config.globalProperties.$dayjs = dayjs;
  app.mount("#corporation-column");
});
